import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
// @ts-ignore
import { AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_SIGNOUT } from '@/store/authorization';
import { NOTIFICATION_MODULE_NAMESPACE, NOTIFICATION_GET_UNREAD_NOTIFICATIONS } from '../../store/notification';
import * as _ from 'lodash';
import { USER_MODULE_NAMESPACE } from '../../store/user/user-types.store';
const UserStore = namespace(USER_MODULE_NAMESPACE);
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE);
const NotificationStore = namespace(NOTIFICATION_MODULE_NAMESPACE);
@Component({
  components: {
    'header-notifications': async () => import('../header-notifications/HeaderNotifications.vue')
  }
})
class HeaderComponent extends Vue {

  dtLanguages: { code: string, key: string, flagIcon: string }[];
  currentLanguage: string = localStorage.getItem('lang') || 'fr';
  @Prop({ default: false, type: [Boolean] })
  enableLogin: boolean;


  dtNotificationVisible: boolean

  @AuthorizationStore.Action(AUTHORIZATION_SIGNOUT)
  storeSignout: (self: any) => Promise<void>;

  @NotificationStore.Action(NOTIFICATION_GET_UNREAD_NOTIFICATIONS)
  storeGetUnreadNotification: (param) => Promise<any>

  @AuthorizationStore.Getter isAuthorized: boolean;
  @UserStore.Getter userInfo: { id: number };
  @NotificationStore.Getter unreadNotifications: { unreadCount: number };
  /**
   *
   */
  constructor() {
    super();

    this.dtNotificationVisible = false;
    this.dtLanguages = require('../../assets/json-resources/language-resource.json');
  }

  get lblSetting() {
    return require('../../locales/generic-labels').default;
  }
  get unreadNumber(): number {
    return this.unreadNotifications.unreadCount
  }
  getDetail(n: any) {
    return {
      name: n.actionOwnerName, ...n.actionDetail
    }
  }
  handleChangeLanguage(languageCode: string) {

    if (this.$i18n.locale !== languageCode) {
      Vue.config['lang'] = languageCode;
      this.$i18n.locale = languageCode;
      this.currentLanguage = languageCode;
      localStorage.setItem('lang', languageCode);
    }
  }
  handleSignOut() {
    this.storeSignout(this)
      .then(res => setTimeout(() => location.href = '/', 1000))
      .catch(err => console.log(err))

  }

  mounted() {
    this.storeGetUnreadNotification({ is_watched: false })
    if (this.userInfo.id) {
      this.handleChangeLanguage(this.currentLanguage);
    }
  }

  getNumberOfLevelsFromPath(path) {
    // Remove leading and trailing slashes
    path = path.replace(/^\/|\/$/g, '');

    // Split the path by slashes
    const segments = path.split('/');

    // Count the number of segments
    const levelCount = segments.length;

    return levelCount;
  }

  get showBackBtn()
  {
    return this.getNumberOfLevelsFromPath(this.$route.fullPath) > 1 ? true : false
  }

  goBack()
  {
    console.log(this.$route)
    console.log(this.$router)
    const fullPath = this.$route.fullPath
    const NumberOfLevelsFromPath = this.getNumberOfLevelsFromPath(fullPath)
    console.log('NumberOfLevelsFromPath = ',NumberOfLevelsFromPath)
    if(this.$route.meta.parent)
    {
      this.$router.replace({name:this.$route.meta.parent, params:this.$route.params})
    }
  }
}

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/header/index.ts